import actions from './actions'

const initialState = {
  usersList: [],
  usersActive: [],
  usersActiveList: [],
  usersInactiveList: [],
  userSearchText: '',
  userInactiveSearchText: '',
  usersListTotal: 0,
  usersListActiveTotal: 0,
  usersListInactiveTotal: 0,
  usersListPagination: {},
  usersListInactivePagination: {},
  usersFilters: {},
  inactiveUsersFilters: {},
  areUsersLoading: false,

  // User-detail page: auth tokens
  uAuthTokensList: [],
  uAuthTokensListTotal: 0,
  uAuthTokensListPagination: {},
  uAuthTokenSearchText: '',

  // User-detail page: this user's friends + add-friend modal
  uFriendsList: [],
  uFriendsListTotal: 0,
  uFriendsListPagination: {},
  userFriendSearchText: '',
  friendUserSearchText: '',
  userNonFriendsList: [],
  nonFriendList: [],
  nonFriendListTotal: 0,
  nonFriendListPagination: {},
  nonFriendSearchText: '',

  // User-detail page: this user's groups + add-to-group modal
  uGroupsList: [],
  uGroupsListTotal: 0,
  uGroupsListPagination: {},
  userGroupSearchText: '',
  groupSearchText: '',
  groupUserSearchText: '',
  userNonGroupsList: [],
  nonGroupList: [],
  nonGroupListTotal: 0,
  nonGroupListPagination: {},
  nonGroupSearchText: '',
}

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
